import React, { useState, useEffect } from "react";
import moment from "moment";
import Button from "../library/Button";
import "./Timer.css";

const pad = (number) => {
  return String(number).padStart(2, "0");
};

const Timer = ({ task, onStopTimer }) => {
  const [_, setElapsedTime] = useState(0);

  const startDate = moment(task.start);
  const now = moment();
  const duration = moment.duration(now.diff(startDate));

  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  useEffect(() => {
    let time = 0;
    const timer = setInterval(() => {
      time++;
      setElapsedTime(time);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className="Timer" data-testid="timer">
      <h1>Currently Tracking</h1>
      <div>{task.name}</div>
      <div className="Timer__Content">
        <div className="Timer__Time">
          {pad(hours)}:{pad(minutes)}:{pad(seconds)}
        </div>
        <Button danger onClick={onStopTimer}>Stop Timer</Button>
      </div>
    </div>
  );
};

export default Timer;
